import React, { useState, useEffect } from "react";
import { useRouter } from 'next/router';

import { MainLinkButton } from "../../styled/buttons/MainLinkButton";

import uiHelpers from '../../../helpers/ui';
import bundlesHelpers from '../../../helpers/bundlesHelpers';

import { CategoryBannerProps } from "../../../types/components/bundles/banners/BundlesCategoryBanner";

export const bannerContainer = "w-full col-span-full"
export const bannerBackgound = "relative w-full h-[170px] rounded-[5px] bg-cover pl-[20px] pr-[20px] xl:pl-[60px] xl:pr-[40px]"
export const gradientOverlay = "absolute inset-0 bg-gradient-to-l from-[#0B1113] to-transparent rounded-[5px]"

export const contentContainer = "relative flex flex-col md:gap-4 z-10 lg:py-0 justify-center lg:flex lg:items-center xl:flex-row xl:justify-between h-full 2xl:px-[40px]"
export const textContainer = "flex flex-col items-center lg:items-start gap-2.5 lg:gap-[2px] w-full"

export const buttonsContainer = "flex mt-4 md:mt-0 items-center justify-center w-full h-fit gap-2 xl:items-center lg:justify-end lg:flex-row";

import { LIBRARY_IDS } from '../../../constants/api';
const { LIBRARY_ID_2D } = LIBRARY_IDS;
import { ENV } from "../../../constants/environments";

const BundlesCategoryBanner: React.FC<CategoryBannerProps> = ({
  category,
  hideIfBundleOwned,
}) => {
  if (!category?.bundle || hideIfBundleOwned && category?.bundle?.owned) return;

  const router = useRouter();

  const [bannerBackgoundStyles, setBannerBackgroundStyles] = useState({});

  useEffect(() => {
    if (!category) return;
    setBannerBackgroundStyles({
      backgroundImage: uiHelpers.generateBannerBackgroundImageFor(category),
    });
  }, [category]);

  const bundleDetailsHandler = () => {
    router.push(`/${category.bundle.library_id === LIBRARY_ID_2D ? 'products' : '3d'}/bundles/${category.bundle.slug}`);
  };

  return (
    <div cy-test-id="bundles-category-banner" key="bundles-banner" className={bannerContainer}>
      <div className={bannerBackgound} style={bannerBackgoundStyles}>
        <div className={gradientOverlay}></div>
        <div className={contentContainer}>

          <div className={textContainer}>
            <div className="flex items-center justify-center w-full gap-2 xl:flex-col lg:justify-start xl:items-start">
              {ENV.displaySaleBanner ? (
                <div className="hidden order-2 xl:order-1 uppercase lg:inline text-black-friday-banner-red-brighter w-max xl:w-fit max-h-[36px] text-[12px] xl:text-[14px] px-[8px] py-2 bg-black-friday-banner-red-default bg-opacity-30 rounded-[5px]" cy-test-id="save-bundles-wording">
                  🔥 limited time: save <b>{bundlesHelpers.getBundleDiscountPercent(category.bundle)}%</b> during the sale!
                </div>
              ) : (
                <div className="hidden order-2 xl:order-1 uppercase lg:inline text-[#FF9D00] w-max xl:w-fit max-h-[36px] text-[12px] xl:text-[14px] px-[8px] py-2 bg-[#FF9D00] bg-opacity-30 rounded-[5px]" cy-test-id="save-bundles-wording">
                  🔥 save {bundlesHelpers.getBundleDiscountPercent(category.bundle)}% with this bundle!
                </div>
                )
              }
              <h1 className='inter xl:order-2 text-[18px] lg:!text-[28px] xl:text-[38px] leading font-bold uppercase tracking-tight' cy-test-id="bundle-name">
                {category.bundle.name}
              </h1>
            </div>
            <div className="uppercase font-light text-[10px] text-center lg:text-start md:text-[12px] lg:text-[12px] w-11/12 xl:w-full">
              Get all <span className='font-bold' cy-test-id="collection-count">{category.bundle.collection_count} collections</span> and <span className='font-bold' cy-test-id="element-count">{category.bundle.element_count} assets</span> for a fraction of the price
            </div>
          </div>

          <div className={buttonsContainer} cy-test-id="action-button">
            <MainLinkButton variant="blue" className="max-w-[150px] md:w-fit px-4 whitespace-nowrap lg:px-[25px] !h-8 md:py-3 md:!h-10 !text-[12px] xl:!text-[17px]" onClick={bundleDetailsHandler}>buy now</MainLinkButton>
          </div>

        </div>
      </div>
    </div>
  )
}

export default BundlesCategoryBanner;
